<template>
  <div class="contech">
    <div class="banner">
         <div class="enTitle">Hello ,ConTech universe</div>
         <div class="zhTitle">内容营销未来式</div>
    </div>
    <div class="lab_banner" v-scroll='scrollLab' :style="animate.lab.bannerStyle"></div>
    <div class="trend">
      <div class="context">
        <div class="title">
          <section>中国移动互联网流量红利见顶，</section>
          <section>品牌营销从“增量竞争”到“存量竞争”的阶段</section>
        </div>
        <div class="chart">
           <img src="https://respool.isheji.com/isheji/static/qiye/image/contech/chart.png">
           <div class="text">2019.06-2021.06 中国移动互联网月活跃用户规模（单位：亿）</div>
        </div>
        <div class='desc'>
          <section>以数据驱动的ADtech</section>
          <section>以技术驱动的Martech</section>
          <section>以算法为核心的内容分发，技术正在全面进入内容行业，</section>
          <section>“内容为王”的时代，如何创造一种以技术驱动的内容生产方式，来满足用户</section>
          <section>个性化的内容需求，创造更好的营销创意呢？</section>
        </div>
      </div>
      <img  src="https://respool.isheji.com/isheji/static/qiye/image/contech/trend.png"> 
    </div>
    <div class="modular">
      <div class="item">
        <div class="title">智能投放</div>
        <div class="desc">
          <section>以数据驱动的ADtech</section>
          <section>媒介环境碎片化衍生不同内容需求</section>
        </div>
        <div class="rect">
         <div class="rItemOut">
          <div class="rItem">
            <div class="rTitle">企业数据库</div>
            <div class="rDesc">Enterprise Database</div>
          </div>
         </div>
         <div class="rItemOut">
            <div class="rItem">
              <div class="rTitle">平台用户画像</div>
              <div class="rDesc">Platform User Portrait</div>
            </div>
         </div>
         <div class="rItemOut">
          <div class="rItem">
            <div class="rTitle">投放分析系统</div>
            <div class="rDesc">Delivery Analysis System</div>
          </div>
         </div>
         <div class="rItemOut">
          <div class="rItem">
            <div class="rTitle">投放策略系统</div>
            <div class="rDesc">Delivery Strategy System</div>
          </div>
         </div>
          
          <div class="fItem">
            ADtech
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">内容中台</div>
        <div class="desc">
          <section>内容自动化</section>
          <section>千人千面的内容需求</section>
        </div>
        <div class="rect">
         <div class="rItemOut">
          <div class="rItem">
            <div class="rTitle">智能创意</div>
            <div class="rDesc">Smart Creative</div>
          </div>
         </div>
         <div class="rItemOut">
          <div class="rItem">
            <div class="rTitle">智能设计</div>
            <div class="rDesc">Smart Design</div>
          </div>
         </div>
          <div class="rItemOut">
           <div class="rItem">
            <div class="rTitle">智能分发</div>
            <div class="rDesc">Smart Content Distribution</div>
          </div>
         </div>
         <div class="rItemOut">
           <div class="rItem">
            <div class="rTitle">数字资产管理</div>
            <div class="rDesc">DAM</div>
          </div>
         </div>
          
          <div class="fItem">
            ConTech
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">数字化营销</div>
        <div class="desc">
          <section>以技术驱动的Martech</section>
          <section>对用户全生命周期的营销管理</section>
          <section>公域获客+私域运营</section>
        </div>
        <div class="rect">
          <div class="rItemOut">
           <div class="rItem">
            <div class="rTitle">全域品牌布点</div>
            <div class="rDesc">Brand Placement</div>
          </div>
         </div>
          <div class="rItemOut">
           <div class="rItem">
            <div class="rTitle">Martech 自动化营销</div>
            <div class="rDesc">Automated Marketing</div>
          </div>
         </div>
           <div class="rItemOut">
            <div class="rItem">
            <div class="rTitle">用户精准触达</div>
            <div class="rDesc">Accurate User Reacht</div>
          </div>
         </div>
         <div class="rItemOut">
           <div class="rItem">
            <div class="rTitle">私域深度运营</div>
            <div class="rDesc">Private Domain Operation</div>
          </div>
         </div>
          
          <div class="fItem">
            Martech
          </div>
        </div>
      </div>
    </div>
    <div class="programme">
      <img v-if="animate.svg.showSvg" class="animate__animated animate__zoomIn" src="https://respool.isheji.com/isheji/static/qiye/image/contech/contech.svg">
      <div class="title">企业级内容创意全链路解决方案</div>
      <div class="tips">打造内容流转全链路数字化的产品矩阵</div>
      <img class="arrow_down animate__animated animate__fadeInDown" src="https://respool.isheji.com/isheji/static/qiye/image/contech/arrow_down.png">
      <img class="rectImg" src="https://respool.isheji.com/isheji/static/qiye/image/contech/contech_desc.png">
    </div>
  </div>
</template>
<script>
import 'animate.css';
export default {
  name: 'HomeView',
    data() {
    return {
      animate:{
        lab:{
          bannerStyle:{
            top:'60'
          }
        },
        svg:{
          showSvg:false
        }
      },
     
    };
  },
  created() {
  },
  mounted(){
    window.addEventListener('scroll',this.scrollSvg,true)
  },
  methods: {
    scrollLab:function(evt,el){
      el.setAttribute(
          'style',
          'top:'+ ( 60 - window.scrollY) +'px'
        )
     
    },
    scrollSvg(){
       if(window.scrollY > 1300){
        this.animate.svg.showSvg = true
      }
    }
  },
}
</script>
<style lang="scss" scoped>
 .lab_banner{
      position: absolute;
      top: 60px;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/contech/animate.png');
      background-repeat: no-repeat;
      background-size: 987px 692px;
      background-position-y: -60px;
      min-width: 1400px;
      background-position-x: 100%;
      width: 100%;
      height: 692px;
  }
  .banner{
    background-image: url(https://respool.isheji.com/isheji/static/qiye/image/contech/banner.png);
    width: 100%;
    min-width: 1400px;
    height: 460px;
    background-size: 1920px 460px;
    background-position-x: center;
    position: relative;
    padding-top: 148px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .enTitle{
      font-size: 45px;
      font-family: LitSans-Medium, LitSans;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 56px;
      margin-bottom: 27px;
      width: 1330px;
    }
    .zhTitle{
      font-size: 59px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 82px;
      letter-spacing: 14px;
      width: 1330px;
    }
  }
  .trend{
    width: 100%;
    min-width: 1400px;
    height: 732px;
    background: #030000;
    display: flex;
    justify-content: center;
    img{
      width: 670px;
      height: 668px;
      padding-top: 32px;
    }
    .context{
      padding-top: 117px;
      text-align: left;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 45px;
      }
      .chart{
        padding:32px 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
        img{
          width: 588px;
          height: 193px;
          margin: 0;
        }
        .text{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #929296;
          line-height: 22px;
          text-align: center;
          margin-top: 16px;
        }
      }
      .desc{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
      }
    }
  }
  .modular{
    width: 100%;
    min-width: 1400px;
    height: 809px;
    background: #030000;
    display: flex;
    justify-content: center;
    padding-top: 80px;
    .item{
      text-align: center;
      margin-right: 100px;
     
      .title{
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 8px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #929296;
        line-height: 22px;
        height: 66px;
      }
      .rect{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 24px;
        padding-bottom: 16px;
        padding-left: 24px;
        padding-right: 24px;
        background: #1C1C23;
        border-radius: 8px;
        margin-top: 16px;
        .rItemOut{
          margin-bottom: 16px;
          border-radius: 4px;
          background:  linear-gradient(90deg, rgba(141, 76, 255, 1), rgba(81, 38, 231, 1));
          padding: 1px;
        }
        .rItem{
          
          width: 285px;
          height: 82px;
          border-radius: 4px;
          border: 1px solid;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          background: #1C1C23;
          .rTitle{
            color: #A675FF;
          }
          .rDesc{
            color: #8C4CFF;
            margin-top: 4px;
          }
        }
        .fItem{
            width: 285px;
            height: 82px;
            background: linear-gradient(90deg, #6D2DDF 0%, #5125E6 100%);
            border-radius: 4px;
            justify-content: center;
            align-items: center;
            display: flex;
            font-size: 32px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 45px;
        }
      }
       &:first-child{
         .rItemOut{
          background:  linear-gradient(90deg, rgba(58, 197, 175, 1), rgba(44, 155, 131, 1));
          padding: 1px;
        }
         .rItem{
           .rTitle{
            color: #2FFFDE;
          }
          .rDesc{
            color: #39C4AE;
          }
          
         }
         .fItem{
           background: linear-gradient(90deg, #3AC5B0 0%, #2C9B83 100%);
         }
       }
       &:last-child{
        margin-right: 0;
        .rItemOut{
          background: linear-gradient(90deg, rgba(30, 110, 223, 1), rgba(19, 64, 200, 1));
          padding: 1px;
        }
        .rItem{
          .rTitle{
            color: #7FB5FF;
          }
          .rDesc{
            color: #1E6EDF;
          }

        }
        .fItem{
          background: linear-gradient(90deg, #1E6FE0 0%, #1340C8 100%);
         }
      }
    }
  }
  .programme{
    height: 1350px;
    width: 100%;
    min-width: 1400px;
    background: #030000;
    background-image: url('https://respool.isheji.com/isheji/static/qiye/image/contech/programme.png');
    background-size: 1200px 1035px;
    background-position-x: center;
    background-position-y: 0;
    background-repeat: no-repeat;
    padding-top: 287px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .rectImg{
      width: 1200px;
    }
    .animate__zoomIn{
      width: 633px;
      height: 130px;
    }
    .title{
      margin-top: 33px;
      font-size: 42px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 59px;
    }
    .tips{
      margin-top: 8px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
    .arrow_down{
      margin-top: 39px;
      margin-bottom: 55px;
    }
    .stepRect{
      width: 1200px;
      display: flex;
      align-items: center;
      padding-left: 27px;
      .title{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        margin-top: 0;
        margin-right: 24px;
      }
      .rect{
        width: 1002px;
        .rowOne{
          display: flex;
          align-items: center;
          padding:0 61px;
          justify-content: space-between;
          height: 100px;
          background: rgba(255, 255, 255, 0.16);
          border-radius: 4px;
          backdrop-filter: blur(10px);
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 25px;
          .img{
            width:21px;
          }
        }
        .rowTwo{
          height: 213px;
          display: flex;
          .doubleLayer{
            display: flex;
            flex-direction: column;
            margin: 8px;
            margin-left: 0px;
            &:nth-child(3){
              margin-right: 0px;
            }
          }
          .singleLayer{
             display: flex;
            flex-direction: column;
            margin: 8px;
            &:nth-child(4){
              margin-right: 0px;
            }
          }
          .item{
              width: 194px;
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              background: rgba(255, 255, 255, 0.16);
              border-radius: 4px;
              backdrop-filter: blur(10px);
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 25px;
              margin-bottom: 8px;
              &:last-child{
                margin-bottom: 0px;
              }
              img{
                height: 26px;
                margin-bottom: 8px;
              }

            }
        }
        .rowThree{
          display: flex;
          .item{
            width: 497px;
            height: 148px;
            background: rgba(255, 255, 255, 0.16);
            border-radius: 4px;
            backdrop-filter: blur(10px);
            display: flex;
            padding-left: 34px;
            align-items: center;
            img{
              width: 80px;
              margin-right: 24px;
            }
            .text{
              .title{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 33px;
                margin-bottom: 6px;
              }
              .desc{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 20px;
              }
            }
          }
          .left{
            margin-right: 8px;
          }
        }
      }
    }
  }
    .animate__animated.animate__fadeInDown {
      animation:fadeInDown 1s infinite alternate;

    }
</style>